import { render, staticRenderFns } from "./injuredFeeItem.vue?vue&type=template&id=a9e14282&scoped=true&"
import script from "./injuredFeeItem.vue?vue&type=script&lang=tsx&"
export * from "./injuredFeeItem.vue?vue&type=script&lang=tsx&"
import style0 from "./injuredFeeItem.vue?vue&type=style&index=0&id=a9e14282&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9e14282",
  null
  
)

export default component.exports